import { useEffect } from 'react'

export default function useResetScroll() {
  useEffect(() => {
    const handleBeforeunload = () => {
      try {
        window.scrollTo(0, 0)
      } catch (e) {
        // 兼容性降级，不需要监控
      }
    }

    window.addEventListener('beforeunload', handleBeforeunload)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeunload)
    }
  })
}
